import React from "react";
import Link from "../../Link";
import { getIcon } from "../../../helpers/icons";
import style from './style.module.css';
import Spinner from "../../Spinner";
const LongButton = ({ onClick, label, massive = false, fetching = false, disabled = false, id = undefined }) => {
    const className = `${style.longBtn}${massive ? ` ${style.massive}` : ``}${disabled ? ` ${style.disabled}` : ``}`;

    const getInnerHtml = () => {
        return (
            <>
                <span className={style.circle}>
                    <i className={getIcon("Circle")} />
                </span>
                <span className={style.label}>{label}</span>
                <span className={style.circle}>
                    <i className={getIcon("Circle")} />
                </span>
            </>
        )
    }
    if (fetching) {
        return (
            <div className={className}>
                <span className={style.loading}><Spinner /></span>
            </div>
        )
    }
    if (disabled) {
        return (
            <div className={className}>
                {getInnerHtml()}
            </div>
        )
    }
    return (
        <Link className={className} onClick={onClick} id={id}>
            {getInnerHtml()}
        </Link>
    )
}
export default LongButton;